import { ArrowLeft, MonitorSmartphone, QrCode, Smartphone, Tv } from 'lucide-react';
import { NamedIcon, Stage } from '@gmp/shared-ui';
import { CATALOG } from '../app/catalog';
import { navigate } from '../app/router';
import { GameCard } from './GameCard';
import { SiteFooter } from '../app/Footer';

export function HowTo({ gameId }: { gameId: string }) {
  const g = CATALOG.find((x) => x.id === gameId)!;
  return (
    <ol className="grid gap-3" data-game={g.id}>
      {g.instructions.map((s, i) => (
        <li key={s.title} className="flex gap-3 items-start">
          <span className="rounded-2xl p-2 bg-[var(--accent)] text-ink shrink-0"><NamedIcon name={s.icon} /></span>
          <div>
            <p className="font-display font-black text-lg">{i + 1}. {s.title}</p>
            <p className="text-mute">{s.body}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}

export function HowToPlay() {
  return (
    <Stage>
      <main className="flex-1 flex flex-col gap-6 safe-pad safe-top safe-bottom py-6 max-w-2xl w-full mx-auto">
        <header className="flex items-center gap-3">
          <button className="btn btn-sm btn-secondary" onClick={() => navigate({ name: 'home' })} aria-label="Back"><ArrowLeft size={18} /></button>
          <h1 className="font-display font-black text-3xl">How to play</h1>
        </header>
        <section className="card p-5 grid gap-4">
          <h2 className="font-display font-black text-2xl">The 30-second version</h2>
          <p className="flex gap-3"><Smartphone className="shrink-0 text-brand" /> One person taps <b>Create Party</b> and shares the 6-letter code or link.</p>
          <p className="flex gap-3"><QrCode className="shrink-0 text-brand" /> Everyone else taps <b>Join Party</b> on their own phone. Nicknames only, no accounts.</p>
          <p className="flex gap-3"><MonitorSmartphone className="shrink-0 text-brand" /> Each phone shows everything: prompts, timers, photos, videos, votes and scores. Play in the same room or across the world.</p>
          <p className="flex gap-3"><Tv className="shrink-0 text-brand" /> Got a TV? The host can open the <b>audience screen</b> link on it. Optional, never required.</p>
        </section>
        {CATALOG.map((g) => (
          <section key={g.id} className="card p-5 grid gap-4" data-game={g.id}>
            <GameCard id={g.id} compact />
            <p className="text-mute">{g.description}</p>
            <HowTo gameId={g.id} />
          </section>
        ))}
        <SiteFooter />
      </main>
    </Stage>
  );
}
